module.exports = __webpack_public_path__ + "static/media/1b_website_logo_org_gdtech.2a7b8587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/1b_website_logo_org_gdtech.jpg
// module id = 38
// module chunks = 0